module.exports = __webpack_public_path__ + "img/nbc_logo.b82959c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/nbc_logo.svg
// module id = ./assets/img/media/nbc_logo.svg
// module chunks = 0 9 11 12